import { ReactNode } from "react";

import { StyledErrorInputMessage } from "./ErrorMessage.style";

type ErrorMessageProps = {
  testId: string;
  errorMessage: ReactNode;
};

function ErrorMessage({ testId, errorMessage }: ErrorMessageProps) {
  return (
    <StyledErrorInputMessage
      data-testid={testId}
      visible={Boolean(errorMessage)}
    >
      {errorMessage}
    </StyledErrorInputMessage>
  );
}

export { ErrorMessage };
